import React from "react"
import useTickers from '../../../hooks/useTickers'
import useProject from "../hooks/useProject"
import { Skeleton, Typography, CardMedia } from '@mui/material'
import SparklineGraph from "../../Graphs/SparklineGraph"
import { marginToPaddingStyles } from '../../Graphs/graphUtils'
import { formatPrice, formatPercent } from '../../../utils/tools'
import styles from './RecentProject.module.scss'
import { useGeneral } from "../../../context/general"

const graphMargin = {top: 4, bottom: 4, right: 4, left: 8}
const skeletonPadding = marginToPaddingStyles(graphMargin)

export default function RecentProject({ ticker, uuid, updated_at, company_name,currency_code, nowcasting,handleCreateProjectAndOpen }) {
    const { setprojectTickerData } = useGeneral()
    const { sparkline } = useProject(ticker)
    const { checkPrivateCompany } = useTickers()

    const privateCompany = checkPrivateCompany(ticker)

    const onClick = () =>{
        setprojectTickerData({"ticker":ticker,'nowcasting':nowcasting,'company_name':company_name})
        handleCreateProjectAndOpen(ticker)
    }

    const projectNames = (
        <div className={styles["projectCard-names"]}>
            <div className={styles["projectCard-date"]}>{new Date(updated_at).toLocaleDateString()}</div>
            <p>{ticker}</p>
            <p className={styles['company-name']}>{!privateCompany && company_name}</p>
        </div>)
    
    const projectNumbers = (
        <div className={styles["projectCard-numbers"]}>
            <Typography variant="h3" className="projectCard-price" >
                {sparkline?.lastPrice
                    ? (privateCompany ? '-' : new Intl.NumberFormat('en-US', { style: 'currency', currency: currency_code?currency_code:'USD' }).format(sparkline.lastPrice))
                    : <Skeleton variant="text" width="3em" />
                }
            </Typography> 
            <p className={styles[sparkline?.diffPrecent < 0 ? 'down' : 'up']}>
                {sparkline
                    ? (privateCompany ? '' : `${formatPrice(sparkline.diff,'always','en-US',currency_code?currency_code:'USD')} (${formatPercent(sparkline.diffPrecent)})`)
                    : <Skeleton variant="text" width="5em" />
                }
            </p>
        </div>
    )

    const projectGraph = (
        <CardMedia className={styles["projectCard-graph"]}>
            {sparkline?.data
                ? <SparklineGraph graph={[sparkline]} margin={graphMargin} />
                : <div style={skeletonPadding}>
                    <Skeleton variant="rect" width="100%" height="100%" />
                </div>
            }
        </CardMedia>)

    return (
        <div className={`${styles['projectCard']}`} onClick={uuid && onClick} >
            <div className={styles["projectCard-content"]}>
                {projectNames}
                {privateCompany ? <p className={styles["public-company-name"]}>{company_name}</p> : projectNumbers}
                {sparkline?.data && projectGraph}
            </div>
        </div>)
}